import { render, staticRenderFns } from "./AdminUserCreate.vue?vue&type=template&id=28c4fd04&scoped=true&"
import script from "./AdminUserCreate.vue?vue&type=script&lang=js&"
export * from "./AdminUserCreate.vue?vue&type=script&lang=js&"
import style0 from "./AdminUserCreate.vue?vue&type=style&index=0&id=28c4fd04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c4fd04",
  null
  
)

export default component.exports